// Do I really need all these polyfills and stuff?
import "core-js/stable";
import "regenerator-runtime/runtime";

import "../scss/app.scss";

import initSliders from "./submodules/slider";
import initPlatform from "./submodules/platform";
import initPardotForms from "./submodules/pardotForm";
import initLoadMore from "./submodules/loadMore";
import initMenu from "./submodules/menu";
import initEmbeddedResizer from "./submodules/embeddedResizer";
import initScrollClass from "./submodules/scrollClass";
import initScrollIntoView from "./submodules/scrollIntoView";
import initAnchorScroll from "./submodules/anchorScroll";
import { initServiceQuestions } from "./submodules/serviceQuestions";
import { initFAQQuestions } from "./submodules/faqQuestion";
import { polyfill } from "seamless-scroll-polyfill";
import initDialog from "./libraries/Dialog";
import { initSetCookie } from "./libraries/Cookies";
import { stickyCta } from "./submodules/stickyCta";
import initPopupVideo from "./submodules/videoPopup";
import initIframePopup from "./submodules/iframePopup";

const tryAll = (...callables: (() => any)[]) => {
  callables.forEach((callable) => {
    if (typeof callable === "function") {
      try {
        callable();
      } catch (e) {
        console.error(`Error in ${callable.name}:`, e);
      }
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  tryAll(
    initDialog,
    polyfill, // Adds smooth scrolling to Safari < 15.4
    initPlatform,
    initSliders,
    initLoadMore,
    initPardotForms,
    initMenu,
    initEmbeddedResizer,
    initScrollClass,
    initScrollIntoView,
    initServiceQuestions,
    initFAQQuestions,
    initAnchorScroll,
    initPopupVideo,
    initIframePopup,
    stickyCta,
    initSetCookie
  );
});
